import PropTypes from 'prop-types'
import { nutritionalDataShape, productShape } from '@proptypes'
import Translation from '#src/common/components/translation'
import { Collapsible } from '#src/products/components/collapsible-section'
import IngredientsComponent from '#src/products/product-details-page/components/ingredients'
import { Button, Content, Item } from './styles'
import Allergens from '../../../../product-details-page/components/allergens'
import ProductCalories from '#src/common/components/product-calories'

export const Ingredients = ({
  allergens,
  id,
  ingredients,
  name,
  nutritionalData
}) => {
  return (
    <Collapsible id={`ingredients-${id}`}>
      <Item index={1}>
        <Collapsible.Header level={4}>
          <Button data-testid={`ingredients-heading-${id}`}>
            <span className='text-grey-700'>
              <Translation id='product.ingredients.heading' />
            </span>
            <span className='sr-only'>{`: ${name}`}</span>
          </Button>
        </Collapsible.Header>
        <ProductCalories
          data-testid='product-calories'
          classes='text-grey-400 font-medium mt-2'
          nutritionalData={nutritionalData}
        />
        <Collapsible.Panel>
          {ingredients && (
            <Content>
              <IngredientsComponent
                className='product-card'
                includeHeading={false}
                ingredients={ingredients}
              />
            </Content>
          )}
          <Allergens allergens={allergens} />
        </Collapsible.Panel>
      </Item>
    </Collapsible>
  )
}

Ingredients.propTypes = {
  id: PropTypes.string.isRequired,
  ingredients: productShape.ingredients,
  name: PropTypes.string.isRequired,
  nutritionalData: nutritionalDataShape,
  allergens: productShape.allergens
}

Ingredients.defaultProps = {
  allergens: [],
  nutritionalData: []
}
